import { Screen } from '~/screens/LegacyContact';

export const LegacyContact: React.FC = () => <Screen />;
